import { SlidersHorizontal } from "lucide-react";

export default function CapsSortDropdown({
  options,
  value,
  onChange,
}) {
  return (
    <label className="relative inline-flex min-w-[180px] items-center">
      <SlidersHorizontal className="pointer-events-none absolute left-4 size-4 text-muted-foreground" />

      <span className="sr-only">Sort caps</span>

      <select
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-11 w-full appearance-none rounded-full border border-border bg-white py-2 pl-11 pr-8 text-sm font-semibold outline-none transition focus:border-neutral-950 focus:ring-2 focus:ring-neutral-950/20"
        aria-label="Sort caps"
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}